import { FEATURE_FLAGS } from '~/constants'
import useAuth from '~/store-v2/auth/useAuth'
import { useFeatureFlag } from '~/store-v2/feature-flag/useFeatureFlag'

// Who can open "Minha carteira". Admin ignores the flag (it can impersonate any partner); a partner
// follows `my_wallet`, which LaunchDarkly serves by the `partner_id` of the logged user.
export function useMyWalletAccess() {
  const { data: auth } = useAuth()
  const { data: flagValue, isLoading: isLoadingFlag } = useFeatureFlag<boolean>(FEATURE_FLAGS.MY_WALLET, false)

  const isAdmin = computed(() => auth.value?.me?.perfil === 'admin')
  const isEnabled = computed(() => isAdmin.value || flagValue.value === true)
  const isLoading = computed(() => !isAdmin.value && (!auth.value || isLoadingFlag.value))

  return { isEnabled, isLoading }
}
